import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("iframe", {
    style: { "display": "none" },
    onload: "resizeTextarea(1,5),resizeTextarea(2,5),resizeTextarea(3,5)"
}, null, -1);
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "mentor_request question"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "メンター申請（審査問い）", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<ul class=\"step_4\"><li class=\"off2\">基本入力</li><li class=\"off2\">経歴入力</li><li class=\"active\">審査問い<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">完了</li></ul><p class=\"lead\">審査のため、次の３つの問いにもご回答お願い致します。</p>", 2);
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = { class: "q_box" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "【問１】", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" 社長から新規事業をいきなり任されました。与えられたテーマもなく困惑しています。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" 会社でも初の試みとのことで、ノウハウもスキルも全員ありません。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" どこから手を付けたらいいものでしょうか？ ")
], -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_14 = {
    key: 0,
    class: "err"
};
const _hoisted_15 = { class: "q_box" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "【問２】", -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("p", null, " ご自分の職種にまつわることで興味があることを、その内容を全く知らない経営者に対して、分かりやすく説明してください。 ", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_19 = {
    key: 0,
    class: "err"
};
const _hoisted_20 = { class: "q_box" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "【問３】", -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", null, "一般に公開しているコンテンツ（ブログ、ＳＮＳ、書籍）があれば、ご紹介ください。", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "optionally" }, "任意"),
    /*#__PURE__*/ _createElementVNode("span", { class: "non_public" }, "非公開")
], -1);
const _hoisted_24 = { class: "bt_box" };
const _hoisted_25 = { class: "err_list" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("button", {
    type: "submit",
    class: "bt_1"
}, "完了", -1);
const _hoisted_27 = {
    id: "modal_confirm",
    class: "modal min2 js-modal"
};
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1);
const _hoisted_29 = { class: "modal-content" };
const _hoisted_30 = { class: "close_bt bt_modal_close" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createTextVNode("以上で入力は完了です。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("申請内容を送信してよろしいですか？")
], -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
], -1);
import { watch, onMounted, onUnmounted, nextTick, ref } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import ImageFrame from '@component/ImageFrame.vue';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'mentor_request_question',
    props: {
        common: null,
        errors: null
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            mentor_answer_1: '',
            mentor_answer_2: '',
            mentor_answer_3: '',
        }, props.common.path);
        // 文字数チェック
        watch(() => form.mentor_answer_1, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.mentor_answer_1 = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.mentor_answer_2, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.mentor_answer_2 = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        watch(() => form.mentor_answer_3, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.mentor_answer_3 = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onClickReturn = () => {
            window.history.back();
        };
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.verify_exam'));
        };
        const confirmModal = ref();
        const onClickConfirm = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.confirm'), () => {
                if (isObjEmpty(props.errors)) {
                    confirmModal.value.click();
                }
            });
        };
        onMounted(() => {
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onClickConfirm, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _hoisted_11,
                                        _hoisted_12,
                                        _hoisted_13,
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).mentor_answer_1) = $event)),
                                            placeholder: "入力してください",
                                            autofocus: "",
                                            id: "textarea_1",
                                            oninput: "resizeTextarea(1,5)"
                                        }, null, 512), [
                                            [_vModelText, _unref(form).mentor_answer_1]
                                        ]),
                                        ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.mentor_answer_1)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(props.errors.mentor_answer_1), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _hoisted_17,
                                        _hoisted_18,
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).mentor_answer_2) = $event)),
                                            placeholder: "入力してください",
                                            id: "textarea_2",
                                            oninput: "resizeTextarea(2,5)"
                                        }, null, 512), [
                                            [_vModelText, _unref(form).mentor_answer_2]
                                        ]),
                                        ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.mentor_answer_2)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.errors.mentor_answer_2), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _hoisted_21,
                                        _hoisted_22,
                                        _hoisted_23,
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).mentor_answer_3) = $event)),
                                            placeholder: "入力してください",
                                            id: "textarea_3",
                                            oninput: "resizeTextarea(3,5)"
                                        }, null, 512), [
                                            [_vModelText, _unref(form).mentor_answer_3]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                            }), 256))
                                        ]),
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    class: "bt_back",
                                                    onClick: onClickReturn,
                                                    value: "戻る"
                                                }, " 戻る ")
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_26,
                                                _createElementVNode("a", {
                                                    class: "bt_1 modal_win",
                                                    "data-target": "modal_confirm",
                                                    ref_key: "confirmModal",
                                                    ref: confirmModal,
                                                    style: { "display": "none" }
                                                }, "完了", 512)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _hoisted_28,
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                            ]),
                                            _createElementVNode("div", { class: "pop" }, [
                                                _hoisted_31,
                                                _createElementVNode("div", { class: "bt_box clear" }, [
                                                    _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                        _hoisted_32,
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("p", {
                                                                class: "bt_modal_close bt_ok",
                                                                onClick: onSubmit
                                                            }, "OK")
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ], 40, _hoisted_9)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
